/**
 * Welcome screen — first-run front door (guest-first onboarding).
 * See specs/guest-first-onboarding/spec.md (Story 1).
 *
 * Visual: onboarding design (dark stadium hero + animated mascot + "zporti" wordmark).
 */

import { getAssetUrl } from '../../../constants/assets';

export const WELCOME_TEST_IDS = {
  CONTAINER: 'welcome-screen',
  GET_STARTED: 'welcome-get-started',
  HAVE_ACCOUNT: 'welcome-have-account',
} as const;

export const WELCOME_COPY = {
  /** Brand name — used as the wordmark's screen-reader label. */
  BRAND: 'Zporti',
  SUBLINE: 'Predict the match.\nClimb the leaderboard.',
  GET_STARTED: 'Get Started',
  HAVE_ACCOUNT: 'I already have an account',
} as const;

/** Full-bleed hero background (R2 CDN). */
export const WELCOME_BACKGROUND_URI = getAssetUrl('assets/backgrounds/welcom_background.webp');
